import { TagSchema } from '../tag.js';
export const GetTagPathRequestSchema = TagSchema.pick({ resourceCorn: true });
export const GetTagQueryRequestSchema = TagSchema.pick({ key: true, value: true }).partial({
    value: true,
});
export const GetTagRequestSchema = GetTagPathRequestSchema.and(GetTagQueryRequestSchema);
export const GetTagResponseSchema = TagSchema;
